var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardHeaderVue',{attrs:{"title":_vm.$route.name,"buttonItems":_vm.buttonItems},on:{"click":_vm.handleHeaderClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }